import axios from 'axios';
import { API_URL, getAuthHeader } from '.';
import { ResponseModel } from '../Models/ResponseModel';
import { ResetPasswordRequest } from '../Models/ResetPasswordRequest';
import { Client } from '../Models/Client';
import { ClientLocation } from '../Models/ClientLocation';
import { Contact } from '../Models/Contact';
import { ClientLocationAsset } from '../Models/ClientLocationAsset';
import { ClientInventoryMarkUp } from '../Models/ClientInventoryMarkUp';
import { Job } from '../Models/Job';
import { ClientMarkUp } from '../Models/ClientMarkUp';

class ClientApi {
  static getClient(id: string) {
    return axios.get<Client>(`${API_URL}/api/client/${id}`, getAuthHeader());
  }

  static createOrLinkQuickBooksCustomer(clientId: number) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/client/${clientId}/quickbooks`,
      null,
      getAuthHeader()
    );
  }
  static addUpdateClient(request: Client) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/client`,
      request,
      getAuthHeader()
    );
  }
  static getClientsList() {
    return axios.get<Client[]>(`${API_URL}/api/client`);
  }
  static getClientLocation(id: number) {
    return axios.get<ClientLocation>(
      `${API_URL}/api/client/location/${id}`,
      getAuthHeader()
    );
  }
  static addUpdateClientLocation(request: ClientLocation) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/client/location`,
      request,
      getAuthHeader()
    );
  }
  static getClientLocationsForClient(id: number) {
    return axios.get<ClientLocation[]>(
      `${API_URL}/api/client/location/client/${id}`,
      getAuthHeader()
    );
  }
  static deleteClientLocation(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/client/location/${id}`,
      getAuthHeader()
    );
  }
  static getContact(id: string) {
    return axios.get<Contact>(
      `${API_URL}/api/client/contact/${id}`,
      getAuthHeader()
    );
  }
  static getContactsForClient(clientId: number) {
    return axios.get<Contact[]>(
      `${API_URL}/api/client/contact/client/${clientId}`,
      getAuthHeader()
    );
  }
  static getLocationsForClient(clientId: number) {
    return axios.get<ClientLocation[]>(
      `${API_URL}/api/client/${clientId}/locations`,
      getAuthHeader()
    );
  }
  static getAssetsForClientLocation(clientLocationId: number) {
    return axios.get<ClientLocationAsset[]>(
      `${API_URL}/api/client/location/${clientLocationId}/asset`,
      getAuthHeader()
    );
  }
  static deleteContact(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/client/contact/${id}`,
      getAuthHeader()
    );
  }
  static addUpdateContact(request: Contact) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/client/contact`,
      request,
      getAuthHeader()
    );
  }
  static getClientsWithLocationList() {
    return axios.get<Client[]>(
      `${API_URL}/api/client/locations`,
      getAuthHeader()
    );
  }
  static addUpdateClientLocationAsset(request: ClientLocationAsset) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/client/location/asset`,
      request,
      getAuthHeader()
    );
  }
  static getClientInventoryMarkUp(id: string) {
    return axios.get<ClientInventoryMarkUp>(
      `${API_URL}/api/client/markup/${id}`,
      getAuthHeader()
    );
  }
  static getClientInventoryMarkUpList(clientId: number) {
    return axios.get<ClientInventoryMarkUp[]>(
      `${API_URL}/api/client/${clientId}/markup/list`,
      getAuthHeader()
    );
  }
  static addUpdateClientInventoryMarkUp(request: ClientInventoryMarkUp) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/client/markup`,
      request,
      getAuthHeader()
    );
  }
  static deleteClientInventoryMarkUp(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/client/markup/${id}`,
      getAuthHeader()
    );
  }
  static getClientJobList(clientId: number) {
    return axios.get<Job[]>(
      `${API_URL}/api/client/${clientId}/job/list`,
      getAuthHeader()
    );
  }
  static getClientInventoryMarkups(clientId: number) {
    return axios.post<ClientMarkUp>(
      `${API_URL}/api/client/${clientId}/markups`,
      null,
      getAuthHeader()
    );
  }
  static getClientLocationAsset(id: number) {
    return axios.get<ClientLocationAsset>(
      `${API_URL}/api/client/clientlocationassets/${id}`,
      getAuthHeader()
    );
  }
}

export default ClientApi;
